// extracted by mini-css-extract-plugin
export var container = "_as-0";
export var containerTopRight = "_as-1";